import { StaffTicket, UpdateStaffTicketRequest } from "@signalist/shared-types";

import { useUpdateStaffTicketMutation } from "@/pages/Private/redux/tickets/tickets-admin.api";

import { isNoOpTriage, TriageFailure, triageFailure } from "../utils/staffTriage";

export type TriageOutcome = { ok: true; changed: boolean } | { ok: false; reason: TriageFailure };

/**
 * One PATCH per rail change (story AC). A value the ticket already has is answered without a
 * request (`changed: false`) — the shared Dropdown re-selects its value from an effect, so the
 * rail asks on every render. The invalidated detail refetches after a real change.
 */
export const useTicketTriage = (ticket: StaffTicket | undefined) => {
	const [update, { isLoading }] = useUpdateStaffTicketMutation();

	const triage = async (fields: UpdateStaffTicketRequest): Promise<TriageOutcome> => {
		if (!ticket) {
			return { ok: false, reason: "FAILED" };
		}

		if (isNoOpTriage(ticket, fields)) {
			return { ok: true, changed: false };
		}

		try {
			await update({ ticketId: ticket.id, ...fields }).unwrap();

			return { ok: true, changed: true };
		} catch (error) {
			return { ok: false, reason: triageFailure(error) };
		}
	};

	return { triage, isTriaging: isLoading };
};
